import { PageContainer } from "src/components/organisms/contents";
import { ReactComponent as IconFamily } from "../../styles/assets/svg/icon_family.svg";
import { ReactComponent as IconReport } from "../../styles/assets/svg/icon_report_alert.svg";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import Toast from "../myInfo/components/InfoToast";
import { useViewport } from "src/common/hooks/ViewPort";
import { SubConHeader } from "src/components/atoms/SubHeaderBox/SubConHeader";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { GET_NOTIFICATION } from "src/common/querykeys";
import { request } from "src/common/api";
import { BaseResponse } from "src/common/types/baseRespones";
import dayjs from "dayjs";
import { useFamilyRegister } from "src/common/hooks/userFamilyRegister";
import { useUserRegister } from "src/common/hooks/useUserRegister";

const tab = ["전체", "루틴", "가족"];

export const AlertCenter = () => {
  const queryClient = useQueryClient();
  const navi = useNavigate();
  const { px } = useViewport();

  const [activeTab, setActiveTab] = useState<string>("전체");
  const [toast, setToast] = useState<string | null>(null);

  const useNotification = () => {
    return useQuery({
      queryKey: [GET_NOTIFICATION],
      queryFn: async () => {
        const result = await request<BaseResponse<any[]>>({
          method: "GET",
          url: `/notification/history`,
        });
        return result.response || [];
      },
    });
  };

  const { data: notificationData = [] } = useNotification();

  // 유저 정보 불러오기
  const { data: userInfo } = useUserRegister();

  // 가족 정보 불러오기
  const { data: familyInfo } = useFamilyRegister();

  const filtered = notificationData.filter((item) =>
    activeTab === "전체" ? true : item.data.category === activeTab
  );

  // 알림 전송하기
  const { mutateAsync: createNotification } = useMutation({
    mutationFn: (payLoad: any) => {
      return request<BaseResponse>({
        method: "POST",
        url: `/notification/send`,
        data: payLoad,
      });
    },
    onSuccess: async () => {
      queryClient.invalidateQueries({ queryKey: [GET_NOTIFICATION] });
    },
  });

  const handleSendAlert = async (payload: any) => {
    await createNotification(payload);
  };

  return (
    <PageContainer isNavBar={false} active={null}>
      <>
        {/* 헤더 */}
        <div
          style={{
            width: "100%",
            maxWidth: "45rem",
            position: "fixed",
            left: "50%",
            transform: "translateX(-50%)",
            top: 0,
            zIndex: 99,
            padding: "0 16px",
          }}
        >
          <SubConHeader
            title="알림 센터"
            onClickArrow={() => navi("/")}
            onClickSetting={() => navi("/alert/setting")}
            setIcon={true}
          />
        </div>

        <div
          style={{
            display: "grid",
            justifyContent: "start",
            gridTemplateColumns: "repeat(5, 1fr)",
            gap: 8,
            fontSize: 16,
            fontWeight: "500",
            lineHeight: "24px",
            padding: "16px 0",
            marginTop: "56px",
          }}
        >
          {/* 탭 메뉴 */}
          {tab.map((item) => (
            <div
              key={item}
              onClick={() => setActiveTab(item)}
              data-active="on"
              data-icon="false"
              style={{
                height: "38px",
                padding: "4px 16px",
                background:
                  activeTab === item
                    ? "var(--neutral-700, #404040)"
                    : "#F5F5F5",
                borderRadius: 50,
                justifyContent: "center",
                alignItems: "center",
                display: "flex",
                cursor: "pointer",
                boxShadow: "0px 4px 11px rgba(0, 0, 0, 0.04)",
                outline: "1px var(--neutral-200, #E5E5E5) solid",
                outlineOffset: "-1px",
              }}
            >
              <div
                style={{
                  justifyContent: "center",
                  display: "flex",
                  flexDirection: "column",
                  color:
                    activeTab === item
                      ? "var(--neutral-50, #FAFAFA)"
                      : "#404040",
                }}
              >
                {item}
              </div>
            </div>
          ))}
        </div>

        {/* 알림 내역 */}
        <div
          style={{
            // maxHeight: "calc(100vh - 126px)",
            display: "flex",
            gap: 16,
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            paddingBottom: "32px",
            overflowY: "auto",
          }}
        >
          {filtered.map((item, idx) => {
            return (
              <div
                key={item.oid}
                style={{
                  width: "100%",
                  height: "100%",
                  padding: "16px 12px",
                  background: "#fff",
                  borderRadius: 16,
                  borderBottom: "1px var(--neutral-200, #E5E5E5) solid",
                  justifyContent: "flex-start",
                  alignItems: "flex-start",
                  gap: 8,
                  display: "flex",
                }}
              >
                <div
                  style={{
                    width: 32,
                    height: 32,
                    position: "relative",
                    background: "#FFEEDA",
                    overflow: "hidden",
                    borderRadius: 12,
                  }}
                >
                  {item.data.theme === "report" ? (
                    <IconReport />
                  ) : (
                    <IconFamily />
                  )}
                </div>
                <div
                  style={{
                    flex: "1 1 0",
                    flexDirection: "column",
                    justifyContent: "flex-start",
                    alignItems: "flex-start",
                    gap: 4,
                    display: "flex",
                  }}
                >
                  <div
                    style={{
                      alignSelf: "stretch",
                      justifyContent: "space-between",
                      alignItems: "flex-start",
                      display: "flex",
                    }}
                  >
                    <div
                      style={{
                        color: "var(--neutral-700, #404040)",
                        fontSize: 14,
                        fontWeight: "700",
                        lineHeight: "20px",
                      }}
                    >
                      {item.data.theme === "report" ||
                      item.data.theme === "routine" ||
                      item.data.type === "medication_reminder"
                        ? item.title
                        : item.data.userName}
                      {(item.data.theme === "응원" ||
                        item.data.theme === "축하") &&
                        "님의 " + item.title}
                    </div>
                    <div
                      style={{
                        color: "var(--neutral-400, #A3A3A3)",
                        fontSize: 13,
                        fontWeight: "500",
                        lineHeight: "20px",
                      }}
                    >
                      {dayjs(item.createdAt).format("MM.DD")}
                    </div>
                  </div>
                  <div
                    style={{
                      flexDirection: "column",
                      justifyContent: "flex-start",
                      alignItems: "flex-start",
                      gap: 4,
                      display: "flex",
                    }}
                  >
                    <div
                      style={{
                        width: "100%",
                        height: "100%",
                        color: "var(--neutral-700, #404040)",
                        fontSize: 14,
                        fontWeight: "500",
                        lineHeight: "20px",
                      }}
                    >
                      {item.data.theme === "routine"
                        ? `${item.data.userName} 님이 ${item.message}`
                        : item.message}
                    </div>
                    {item.data.theme === "report" && (
                      <>
                        <div
                          style={{
                            width: "100%",
                            height: "100%",
                            color: "var(--neutral-700, #404040)",
                            fontSize: 14,
                            fontWeight: "500",
                            lineHeight: "20px",
                          }}
                        >
                          당신의 건강 루틴, 얼마나 잘 지켰을까요?
                        </div>
                        <div
                          style={{
                            color: "var(--neutral-700, #A3A3A3)",
                            fontSize: 14,
                            fontWeight: "500",
                            lineHeight: "20px",
                            cursor: "pointer",
                          }}
                          onClick={() => navi("/report")}
                        >
                          자세히보기
                        </div>
                      </>
                    )}
                    {item.data.theme === "routine" && (
                      <div
                        data-size="S"
                        style={{
                          width: "100%",
                          height: "100%",
                          padding: "8px 12px",
                          background: "#FFEEDA",
                          boxShadow: "0px 4px 11px rgba(0, 0, 0, 0.04)",
                          borderRadius: 8,
                          justifyContent: "center",
                          alignItems: "center",
                          gap: 10,
                          display: "flex",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          const dayCount =
                            item.message.match(/^(\d+)일/)?.[1] || "";

                          const matchedFamily = familyInfo?.find(
                            (f: any) => f.userName === item.data.userName
                          );

                          handleSendAlert({
                            userOid: matchedFamily?.oid,
                            title: "축하 메세지",
                            message:
                              dayCount +
                              "일 연속이라니... 이 정도면 건강 루틴 장인🎖️",
                            data: {
                              userName: userInfo?.userName,
                              category: "가족",
                              theme: "축하",
                            },
                          });
                          setToast(
                            `${item.data.userName}에게 축하 메시지를 보냈어요!`
                          );
                        }}
                      >
                        <div
                          data-icon="true"
                          style={{
                            justifyContent: "flex-start",
                            alignItems: "center",
                            gap: 4,
                            display: "flex",
                            cursor: "pointer",
                          }}
                        >
                          <div
                            data-bg="false"
                            data-icon="emoji_confetti"
                            data-rtbtn="none"
                            style={{
                              width: 16,
                              height: 16,
                              position: "relative",
                              fontSize: 16,
                            }}
                          >
                            🎉
                          </div>
                          <div
                            style={{
                              justifyContent: "center",
                              display: "flex",
                              flexDirection: "column",
                              color: "var(--neutral-600, #525252)",
                              fontSize: 14,
                              fontWeight: "500",
                              lineHeight: "20px",
                            }}
                          >
                            축하해주기
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
        <Toast
          message={toast ?? ""}
          open={!!toast}
          px={px}
          onClose={() => setToast(null)}
        />
      </>
    </PageContainer>
  );
};
